// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OGVZ","comment":"styles_comment__99c_b"};